export const NewTabIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14V0H7V1.5H1.5V12.5H12.5V7H14V14H0ZM5.0625 10L4 8.9375L11.4375 1.5H9V0H14V5H12.5V2.5625L5.0625 10Z"
      fill="currentColor"
    />
  </svg>
);
